@if (previewData) {
  <div class="form-preview">
    <!-- Forms are filled in the field app, so the preview is framed as a phone:
         the same renderers the daily report uses, at a handset width. -->
    <div class="device">
      <div class="device-frame">
        <div class="device-island"></div>
        <div class="device-screen">
          @if (signatureView) {
            <!-- Pushed signature screen, mirroring the field app's: Done, a Role
                 picker, then a typed name or a printed name over a signing pad. -->
            <div class="device-appbar">
              <mat-icon class="appbar-icon appbar-back" (click)="closeSignature()">arrow_back</mat-icon>
              <span class="appbar-title">Signature</span>
              <span class="appbar-done" (click)="closeSignature()">Done</span>
            </div>

            <div class="device-scroll">
              <div class="sheet-label">Role</div>
              <div class="sheet-field sheet-field-select">
                <span class="sheet-placeholder">Select a role</span>
                <mat-icon class="sheet-caret">expand_more</mat-icon>
              </div>
              <div class="sheet-roles">
                @for (role of signatureRoles; track role) {
                  <span class="sheet-role">{{ role }}</span>
                }
              </div>

              @if (signaturePadEnabled) {
                <div class="sheet-label">
                  Printed name @if (requirePrintedName) {<span class="sheet-required">*</span>}
                </div>
                <div class="sheet-field">
                  <span class="sheet-placeholder">Enter printed name</span>
                </div>

                <div class="sheet-pad">
                  <span class="sheet-pad-hint">Sign here</span>
                </div>
                <div class="sheet-pad-actions">Clear</div>
              } @else {
                <div class="sheet-label">Signature</div>
                <div class="sheet-field">
                  <span class="sheet-placeholder">Type a name</span>
                </div>
              }
            </div>
          } @else if (questionsView) {
            <!-- Pushed questions screen, mirroring the field app's: back to the
                 form, "n / N" with arrows, a progress bar, one question at a
                 time, and the response options as a segmented pill. -->
            <div class="device-appbar">
              <mat-icon class="appbar-icon appbar-back" (click)="closeQuestions()">arrow_back</mat-icon>
              <span class="appbar-title">{{ questionIndex + 1 }} / {{ questionCount }}</span>
              <span class="appbar-arrows">
                <mat-icon
                  class="appbar-icon"
                  [class.is-disabled]="questionIndex === 0"
                  (click)="previousQuestion()"
                  >chevron_left</mat-icon>
                <mat-icon
                  class="appbar-icon"
                  [class.is-disabled]="questionIndex >= questionCount - 1"
                  (click)="nextQuestion()"
                  >chevron_right</mat-icon>
              </span>
            </div>

            <div class="question-progress">
              <div class="question-progress-bar" [style.width.%]="progress"></div>
            </div>

            <div class="device-scroll">
              <div class="question-section">{{ questionsView.label }}</div>
              <div class="question-text">{{ question?.label }}</div>

              <div class="question-options">
                @for (option of questionsView.options; track option) {
                  <button
                    type="button"
                    class="question-option"
                    [class.is-selected]="answerFor(question) === option"
                    (click)="answer(option)"
                    >
                    {{ option }}
                  </button>
                }
              </div>
            </div>
          } @else {
            <div class="device-appbar">
              <mat-icon class="appbar-icon">arrow_back</mat-icon>
              <span class="appbar-title">{{ form?.name }}</span>
            </div>

            <div #scroller class="device-scroll">
              <!-- Keyed by form id so switching forms DESTROYS + recreates the
                   renderer: they hydrate in ngOnInit only, so a reused instance
                   would keep showing the previously selected form's fields. -->
              @for (formId of [form?.id]; track formId) {
                @switch (renderer) {
                  @case ('generic') {
                    <app-generic-form
                      [data]="previewData"
                      [options]="{ preview: true }"
                      (previewQuestions)="openQuestions($event)"
                      (previewSignature)="openSignature()"
                      />
                  }
                  @case ('testing') {
                    <app-testing-from
                      [data]="previewData"
                      [options]="{ preview: true }"
                      (previewSignature)="openSignature()"
                      />
                  }
                  @default {
                    <app-control-forms-details
                      [data]="previewData"
                      [options]="{ preview: true }"
                      (previewQuestions)="openQuestions($event)"
                      (previewSignature)="openSignature()"
                      />
                  }
                }
              }
            </div>
          }
        </div>
        <div class="device-home"></div>
      </div>

      <div class="device-note">
        The blank form as an inspector sees it in the field app. Nothing typed here is saved.
      </div>
    </div>
  </div>
}
